// MiniArtZone Theme v9.1 — Optimized for speed
document.addEventListener('DOMContentLoaded', function () {

  // ── MOBILE DRAWER ──
  var drawer = document.getElementById('mazDrawer');
  var overlay = document.getElementById('mazOverlay');
  var close = document.getElementById('mazClose');
  var ham = document.getElementById('mazHam');

  function openD() { if(drawer)drawer.classList.add('open'); if(overlay)overlay.classList.add('show'); document.body.style.overflow='hidden'; }
  function closeD() { if(drawer)drawer.classList.remove('open'); if(overlay)overlay.classList.remove('show'); document.body.style.overflow=''; }
  if(ham) ham.addEventListener('click', openD);
  if(close) close.addEventListener('click', closeD);
  if(overlay) overlay.addEventListener('click', closeD);

  // ── STICKY HEADER SHADOW (throttled) ──
  var nav = document.querySelector('.nav');
  var ticking = false;
  if(nav) window.addEventListener('scroll', function(){
    if(!ticking){ window.requestAnimationFrame(function(){ nav.classList.toggle('scrolled', window.scrollY > 10); ticking=false; }); ticking=true; }
  }, {passive:true});

  // ── FAQ ──
  document.querySelectorAll('.faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = this.closest('.faq-item');
      var open = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i){ i.classList.remove('open'); });
      if(!open) item.classList.add('open');
    });
  });

  // ── SCROLL REVEAL (lightweight) ──
  if('IntersectionObserver' in window){
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('visible'); obs.unobserve(e.target); } });
    }, {threshold: 0.05});
    document.querySelectorAll('.fade-in').forEach(function(el){ obs.observe(el); });
  } else {
    document.querySelectorAll('.fade-in').forEach(function(el){ el.classList.add('visible'); });
  }

  // ── CART AJAX ──
  window.mazUpdateCart = function(key, qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
    .then(function(){ window.location.reload(); });
  };

});
